import Card from 'components/models/card'
import {
  Button,
  Flex,
  Grid,
  Heading,
  Spinner,
  useBreakpointValue,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import Link from 'next/link'

export default function Models(props) {
  const [posts, setPosts] = useState(undefined)

  const [pageNumber, setPageNumber] = useState(0)

  useEffect(() => {
    async function fetcher() {
      try {
        let res = await fetch(
          window.location.origin +
            '/api/posts?skip=' +
            pageNumber * 8 +
            '&limit=' +
            8,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        let allPosts = await res.json()

        setPosts([...allPosts.data])

        return {
          props: { isConnected: true, allPosts },
        }
      } catch (e) {
        console.error(e)
        return {
          props: { isConnected: false },
        }
      }
    }

    fetcher()
  }, [pageNumber])

  const isLandscape = useBreakpointValue({ base: false, md: true })

  return (
    <Flex
      p={'15px'}
      overflowY={'auto'}
      height={'100vh'}
      direction={'column'}
      alignItems={'center'}
    >
      <Heading>Design Inspirations</Heading>
      {posts &&
        !isLandscape &&
        posts.map((post, index) => {
          return (
            <Card
              key={index}
              name={post.name}
              id={post._id}
              geometryStatePost={post}
            ></Card>
          )
        })}
      {posts && isLandscape && (
        <Grid templateRows='repeat(2, 1fr)' templateColumns='repeat(4, 1fr)'>
          {posts.map((post, index) => {
            return (
              <Card
                key={index}
                name={post.name}
                id={post._id}
                geometryStatePost={post}
              ></Card>
            )
          })}
        </Grid>
      )}
      {posts && posts.length == 0 && <Flex> No models to display ! </Flex>}
      <Flex direction={'row'}>
        {!posts && (
          <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='black.500'
            marginTop='3rem'
            size='xl'
          />
        )}
        {posts && (
          <Link href='/'>
            <Button flexShrink={0} marginRight='1em'>
              Back
            </Button>
          </Link>
        )}

        {posts && pageNumber > 0 && (
          <Button
            onClick={() => setPageNumber((v) => v - 1)}
            flexShrink={0}
            marginRight='1em'
          >
            Previous
          </Button>
        )}

        {posts && posts.length == 8 && (
          <Button onClick={() => setPageNumber((v) => v + 1)} flexShrink={0}>
            Next
          </Button>
        )}
      </Flex>
    </Flex>
  )
}
